import { BotProfileRailbar } from "./BotProfileRailbar";
import { CommunityMemberRailbar } from "./CommunityMemberRailbar";

export const Railbar = ({
  author = {},
  isDms,
  conversationStatus = "normal",
}: {
  author: any;
  isDms: boolean;
  conversationStatus?: "getting_too_long" | "too_long" | "exceeded" | "normal";
}) => {
  if (isDms) {
    return (
      <BotProfileRailbar
        botProfile={author}
        conversationStatus={conversationStatus}
      />
    );
  }
  return <CommunityMemberRailbar communityMember={author} />;
};
